import { render, staticRenderFns } from "./ConnectedSwitch.vue?vue&type=template&id=3a486c5a"
import script from "./ConnectedSwitch.vue?vue&type=script&lang=js"
export * from "./ConnectedSwitch.vue?vue&type=script&lang=js"
import style0 from "./ConnectedSwitch.vue?vue&type=style&index=0&id=3a486c5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports